import { useEffect, useRef } from 'react';

const ServiceSlider = () => {
  const sectionRef = useRef(null);
  const services = [
    "Embroidery Digitizing",
    "Vector Art & DTF",
    "Website Development",
    "Logo Designing"
  ];

  useEffect(() => {
    if (!sectionRef.current) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-active');
          } else {
            entry.target.classList.remove('is-active');
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="service-slider-sec is-active" ref={sectionRef}>
      <div className="slider-track">
        <div className="slider-content">
          {[...Array(3)].map((_, setIndex) => (
            <div key={setIndex} className="slider-set">
              {services.map((service, index) => (
                <div key={`${setIndex}-${index}`} className="slider-item-wrapper">
                  <div className="slider-item">
                    <span className="service-text" data-text={service}>
                      {service}
                    </span>
                  </div>
                  <div className="slider-icon">
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                      <circle cx="15" cy="15" r="3" fill="var(--primary-color)" />
                      <circle cx="15" cy="15" r="12" stroke="var(--primary-color)" strokeWidth="2" opacity="0.3" />
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSlider;